/**
 * @ngdoc Directive
 * @name vrm-validation-contains-url
 * @example
 *
 * <vrm-validation-contains-url />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmValidationContainsUrl', vrmValidationContainsUrl)

    
    /* @ngInject */
    function vrmValidationContainsUrl() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        function link(scope, elem, attr, ctrl) {
            scope.$watch(function() {
                return scope.$eval(attr.vrmValidationContainsUrl);
            }, function() {
                ctrl.$validate()
            });
            ctrl.$validators.url = function(modelValue, viewValue) {
                const value = modelValue || viewValue || '';
                return value.match(/((http:\/\/)|(https:\/\/))\S+/i) === null;
            };
        }
    }
})();
